<template>
    <div>
        <b-table
            class="table-dark"
            :items="sessions"
            :fields="fields"
            sortBy="createdAt"
            sortDesc
            @row-clicked="(record) => selectSession(record.sessionId)"
        >
            <template #cell(createdAt)="data">
                {{ formatDateTime(data.value) }}
            </template>

            <template #cell(actions)="row">
                <b-button v-b-modal.editModal @click="setEditSession(row.item)"
                    >Edit</b-button
                >
            </template>
        </b-table>

        <b-modal
            v-if="$store.getters.isAdmin"
            id="editModal"
            title="Edit Session"
            @ok="updateSession(editSession)"
        >
            <SessionEdit :session="editSession" />
        </b-modal>
    </div>
</template>

<script>
import { formatDateTime } from "../utils";
import SessionEdit from "./SessionEdit";
import api from "@/api";

export default {
    name: "SessionList",
    props: {
        userId: { 
            type: String
        }
    },
    data() {
        return {
            sessions: [],
            fields: [
                { key: 'sessionName', label: 'Session Name', sortable: true },
                { key: 'createdAt', label: 'Date Created', sortable: true },
            ],
            editSession: null,
        };
    },
    computed: {},
    methods: {
        formatDateTime,

        selectSession(id) {
            this.$emit("selectSession", id);
        },

        setEditSession(session) {
            let {
                sessionId,
                sessionName,
                numberOfHosts,
                isHostConnectionOnly,
                isHostMustAdmit,
            } = session;

            this.editSession = {
                sessionId,
                sessionName,
                numberOfHosts,
                isHostConnectionOnly,
                isHostMustAdmit,
            }
        },

        async updateSession(session) {
            if (session) {
                let result = await api.sessions.update(session);
                let {error, message} = result;
                if (error) console.error(message);

                this.loadSessions();
            }
        },

        async loadSessions() {
            let result = await api.sessions.getByUserId(this.userId);

            let { error, message, results } = result;
            if (error) {
                console.error(message);
                return;
            }

            let { sessions } = results;
            // don't show old format sessions
            this.sessions = sessions.filter(
                (item) => item.createdAt != undefined
            );
        },
    },

    components: {
        SessionEdit,
    },

    beforeMount() {
        if (this.$store.getters.isAdmin) {
            this.fields.push({ key: 'actions', label: 'Actions' });
        }

        this.loadSessions();
    },
};
</script>